var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebViewer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 43,
    viewBox: "0 0 46 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3046 6.39252H17.0967C16.5427 6.39252 16.0938 5.94355 16.0938 5.38962C16.0938 4.83569 16.5427 4.38672 17.0967 4.38672H34.3046C34.8586 4.38672 35.3075 4.83569 35.3075 5.38962C35.3075 5.94355 34.8586 6.39252 34.3046 6.39252Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7597 10.666H17.0967C16.5427 10.666 16.0938 10.217 16.0938 9.66306C16.0938 9.10913 16.5427 8.66016 17.0967 8.66016H24.7597C25.3137 8.66016 25.7626 9.10913 25.7626 9.66306C25.7628 10.217 25.3138 10.666 24.7597 10.666Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46 42.1303H0V2.01053C0 0.900118 0.900118 0 2.01053 0H43.9895C45.0999 0 46 0.900118 46 2.01053V42.1303Z",
    fill: "#E9EDF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9895 0H2.01053C0.900118 0 0 0.491454 0 1.09773V8H46V1.09773C46 0.491454 45.0999 0 43.9895 0Z",
    fill: "url(#paint0_linear_328_2489)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3027 32.6445C34.8567 32.6445 35.3057 33.0935 35.3057 33.6475C35.3055 34.2013 34.8566 34.6504 34.3027 34.6504H27.5166C26.9628 34.6504 26.5138 34.2013 26.5137 33.6475C26.5137 33.0935 26.9627 32.6445 27.5166 32.6445H34.3027ZM42.041 28.2344C42.5949 28.2344 43.0439 28.6834 43.0439 29.2373C43.0437 29.791 42.5948 30.2402 42.041 30.2402H27.5166C26.9628 30.2402 26.5139 29.791 26.5137 29.2373C26.5137 28.6834 26.9627 28.2344 27.5166 28.2344H42.041ZM42.041 23.8232C42.5948 23.8233 43.0437 24.2715 43.0439 24.8252C43.0441 25.3791 42.5949 25.8281 42.041 25.8281H27.5166C26.9627 25.8281 26.5137 25.3791 26.5137 24.8252C26.5139 24.2715 26.9628 23.8232 27.5166 23.8232H42.041ZM42.041 19.4111C42.5949 19.4112 43.0439 19.8601 43.0439 20.4141C43.0439 20.9679 42.5949 21.417 42.041 21.417H27.5166C26.9627 21.417 26.5137 20.9679 26.5137 20.4141C26.5137 19.8601 26.9627 19.4111 27.5166 19.4111H42.041ZM42.041 15C42.5948 15 43.0438 15.4492 43.0439 16.0029C43.0441 16.5569 42.5949 17.0059 42.041 17.0059H27.5166C26.9627 17.0059 26.5137 16.5569 26.5137 16.0029C26.5138 15.4491 26.9628 15 27.5166 15H42.041Z",
    fill: "url(#paint1_linear_328_2489)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0158 33.6475H5.49596C4.95238 33.6475 4.51172 33.2068 4.51172 32.6632V16.1434C4.51172 15.5998 4.95238 15.1592 5.49596 15.1592H22.0158C22.5593 15.1592 23 15.5998 23 16.1434V32.6632C22.9999 33.2068 22.5593 33.6475 22.0158 33.6475Z",
    fill: "url(#paint2_linear_328_2489)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23 32.6637V27.9818C22.5549 27.7951 22.0692 27.6555 21.5489 27.5972C18.9958 27.3116 18.6535 29.3213 16.173 29.5225C12.5071 29.8198 11.4406 25.5772 7.62039 25.8095C6.37958 25.8849 5.32414 26.4036 4.51172 26.985V32.6637C4.51172 33.2073 4.95238 33.648 5.49596 33.648H5.86797H21.6436H22.0156C22.5595 33.648 23 33.2073 23 32.6637Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4018 23.538C17.5428 23.538 18.4677 22.6131 18.4677 21.4721C18.4677 20.3312 17.5428 19.4062 16.4018 19.4062C15.2609 19.4062 14.3359 20.3312 14.3359 21.4721C14.3359 22.6131 15.2609 23.538 16.4018 23.538Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_328_2489",
    x1: 23,
    y1: 8,
    x2: 23,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#177BF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DAD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_328_2489",
    x1: 34.7788,
    y1: 34.6504,
    x2: 34.7788,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#177BF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DAD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_328_2489",
    x1: 13.7559,
    y1: 33.6475,
    x2: 13.7559,
    y2: 15.1592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#177BF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DAD9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebViewer);
export default __webpack_public_path__ + "static/media/web_viewer.b6f16cafe115adb89521369bb64ec34f.svg";
export { ForwardRef as ReactComponent };